import { VariantId } from '@candu-ai/content/types';
import { BuiltInComponents } from 'craft/constants';
import {
  CssSelectorDefinitions,
  CssSelectorId,
  CssSelectorType,
  HANDLER_TYPES,
  INTERACTION_TYPES,
  SerializedNodeTree,
  TRIGGERS,
} from 'craft/types';

const TOUR_TITLE = 'Say hello to your Tour Step';
const TOUR_DESCRIPTION = 'Add some descriptive text here.';

interface Props {
  contentName: string;
  variantId: VariantId;
}

export const getSubsequentTourStep = ({ contentName, variantId }: Props) =>
  (({
    rootNodeId: '3bBlLh',
    nodes: {
      '3bBlLh': {
        type: {
          resolvedName: BuiltInComponents.TourStep,
        },
        props: {
          hasDismiss: true,
          variant: variantId,
        },
        nodes: ['3E6PAG', '1cvud1'],
        custom: {
          actions: [
            {
              eventName: `Dismissed Tour ${contentName}`,
              category: INTERACTION_TYPES.Dismiss,
            },
          ],
          cssSelectors: {
            [CssSelectorId.TourStepBody]: {
              selector: CssSelectorDefinitions[CssSelectorId.TourStepBody].selector,
              type: CssSelectorType.HTML,
              css: {
                width: '300px',
              },
            },
          },
        },
      },
      '3E6PAG': {
        type: {
          resolvedName: BuiltInComponents.RichTextEditor,
        },
        name: 'RichText',
        parent: '3bBlLh',
        props: {},
        nodes: ['43dVfQ', '4gnwVC'],
      },
      '43dVfQ': {
        type: {
          resolvedName: BuiltInComponents.Typography,
        },
        name: 'Typography',
        props: {},
        custom: {
          custom: {
            variant: 'P',
            variation: 'base',
          },
          css: {
            fontSize: '16px',
            marginTop: '0px',
            marginBottom: '4px',
          },
        },
        parent: '3E6PAG',
        nodes: ['3zwvdV'],
      },
      '3zwvdV': {
        type: {
          resolvedName: BuiltInComponents.Text,
        },
        props: {
          childrenString: TOUR_TITLE,
        },
        name: 'Text',
        custom: {
          custom: {
            marks: ['B'],
          },
        },
        parent: '43dVfQ',
      },
      '4gnwVC': {
        type: {
          resolvedName: BuiltInComponents.Typography,
        },
        name: 'Typography',
        props: {},
        custom: {
          custom: {
            variant: 'P',
            variation: 'base',
          },
          css: {
            marginTop: '0px',
            marginBottom: '16px',
          },
        },
        parent: '3E6PAG',
        nodes: ['19yjT'],
      },
      '19yjT': {
        type: {
          resolvedName: BuiltInComponents.Text,
        },
        props: {
          childrenString: TOUR_DESCRIPTION,
        },
        name: 'Text',
        parent: '4gnwVC',
      },
      '1cvud1': {
        type: {
          resolvedName: BuiltInComponents.View,
        },
        name: 'View',
        parent: '3bBlLh',
        props: {},
        custom: {
          css: {
            display: 'flex',
            flexGrow: 1,
            justifyContent: 'flex-end',
            paddingBottom: '0px',
            paddingLeft: '0px',
            paddingRight: '0px',
            paddingTop: '0px',
          },
        },
        nodes: ['14ds12', '15pe2l'],
      },
      '14ds12': {
        type: {
          resolvedName: BuiltInComponents.Button,
        },
        custom: {
          actions: [
            {
              trigger: TRIGGERS.ON_CLICK,
              handler: {
                type: HANDLER_TYPES.PREVIOUS_TOUR_STEP,
              },
              eventName: 'Previous Tour Step',
              category: 'Tour',
            },
          ],
        },
        props: {
          outline: 'solid',
          size: 'md',
          color: 'primary',
          childrenString: 'Previous',
          variant: 'secondary',
        },
        name: 'Button',
        parent: '1cvud1',
      },
      '15pe2l': {
        type: {
          resolvedName: BuiltInComponents.Button,
        },
        custom: {
          actions: [
            {
              trigger: TRIGGERS.ON_CLICK,
              handler: {
                type: HANDLER_TYPES.NEXT_TOUR_STEP,
              },
              eventName: 'Next Tour Step',
              category: 'Tour',
            },
          ],
          css: {
            marginLeft: '8px',
          },
        },
        props: {
          outline: 'solid',
          size: 'md',
          color: 'primary',
          childrenString: 'Next',
          variant: 'base',
        },
        name: 'Button',
        parent: '1cvud1',
      },
    },
  } as unknown) as SerializedNodeTree);
